import CustomCard from "components/CustomCard/CustomCard";
import News1 from "assets/images/News1.png";
import News2 from "assets/images/News2.png";
import RiskNews from "assets/images/RiskNews.svg";

export default function NewsTrends() {
  return (
    <div className="pv-3">
      <div className="row">
        <div className="col">
          <CustomCard img={News1} title="Real estate, real wages, and real supply chain madness" subTitle="Business" content="April 20, 2023 • NPR" position="end"/>
        </div>
        <div className="col">
            <div className="d-flex flex-column gap-4">
              <CustomCard img={News2} title="A deal to avert a rail strike is on track, but it won't fix U.S. supply chain issues" position="end"/>
              <CustomCard img={RiskNews} title="2022 was a big year for EV battery plants in the U.S. How big? $73 billion big" position="end" />
            </div>
        </div>
      </div>
    </div>
  );
}
